module.exports = __webpack_public_path__ + "img/add_discussion_bg.359ed2ee.png";